import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../../@types/RootState';
import { ContextMenu, ContextMenuContent, ContextMenuTrigger } from '../../../../../components';
import { selectorContextMenu } from '../../../../../reducers/gerenciadorPrecos/contextMenu';
import OptimizationContextMenu from './OptimizationContextMenu/OptimizationContextMenu';
import PriceCompositionContextMenu from './PriceComposition/PriceCompositionContextMenu';
import PriceEventHistoryContextMenu from './PriceEventHistory/PriceEventHistoryContextMenu';
import RuleCompositionContextMenu from './RuleComposition/RuleCompositionContextMenu';
import RuleCompositionOfferContextMenu from './RuleCompositionOffer/RuleCompositionOfferContextMenu';
import UndoPriceChangesContextMenu from './UndoPriceChangesContextMenu';

type PriceManagerContextMenuProps = {
  children: ReactNode;
} & ReturnType<typeof mapStateToProps>;

const PriceManagerContextMenu = ({ children, contextMenuDatapoint }: PriceManagerContextMenuProps) => {
  return (
    <ContextMenu>
      <ContextMenuTrigger>{children}</ContextMenuTrigger>
      <ContextMenuContent>
        {contextMenuDatapoint && (
          <>
            <UndoPriceChangesContextMenu />
            <OptimizationContextMenu />
            <PriceCompositionContextMenu />
            <RuleCompositionContextMenu />
            <RuleCompositionOfferContextMenu />
            <PriceEventHistoryContextMenu />
          </>
        )}
      </ContextMenuContent>
    </ContextMenu>
  );
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
});

export default connect(mapStateToProps)(PriceManagerContextMenu);
